<div id="{{id}}" class='element template-element build-template' data-position="{{position}}">
  <div class="template-content">
    <i class="fa fa-arrow-circle-down"></i>

    <div class="main">
      <div class="header">Template Area: <span class="title">{{title}}</span></div>

      <div class="description">{{{description}}}</div>
    </div>

    <div data-toggle="tooltip" data-html="true" title="Pages that use this template can add elements in this area.">
      <i class='fa fa-info-circle'></i>
    </div>
  </div>
</div>
